import * as React from 'react';
import { ProductsContext } from 'Jsx/ContextApis/Products';

import App from './App';

const Main = props => {
  const { shoppingCartState } = React.useContext(ProductsContext);

  return <App {...props} shoppingCart={{ ...shoppingCartState }} />;
};

export default Main;
